import { Box, Paper, Typography } from '@mui/material'
import React from 'react'
import RequiredLabelComponent from '../required-label-component'
import Icon from '../icon'

const ResumeUpload = ({
  id = 'upload-resume',
  label,
  error = '',
  value = null,
  isRequired = false,
  handleChange = () => {},
  formats = ['.pdf', '.docx', '.doc']
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
      {label && (
        <RequiredLabelComponent
          label={label}
          required={isRequired}
          error={Boolean(error)}
        />
      )}
      <Paper
        variant="outlined"
        sx={{
          borderStyle: 'dashed',
          padding: 3,
          cursor: 'pointer',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          flex: 1,
          '&:hover': { borderColor: 'primary.main' }
        }}
        onClick={() => document.getElementById(`file-input-${id}`).click()}
      >
        <Icon
          icon={'material-symbols:upload'}
          nonHoverBoxStyle={{ width: 'max-content' }}
          style={{ fontSize: '2rem', color: 'var(--primary-main)' }}
        />
        <Typography variant="body1" sx={{ mt: 1 }}>
          Click to select a file
        </Typography>
        {formats?.length > 0 && (
          <Typography variant="body2" color="text.secondary">
            {`Supported formats: ${formats?.join(', ')}`}
          </Typography>
        )}
        <input
          id={`file-input-${id}`}
          type="file"
          hidden
          {...(formats?.length > 0 ? { accept: formats } : {})}
          onChange={(e) => {
            if (e?.target?.files?.[0]) {
              handleChange(e?.target?.files?.[0])
            }
            e.target.value = null
          }}
        />
        {value && (
          <Box sx={{ gap: '8px', display: 'flex' }}>
            <Typography variant="body2" sx={{ mt: 2 }}>
              Selected: <strong>{value?.name}</strong>
            </Typography>
            <Icon
              hoverEffect
              icon={'carbon:close-outline'}
              onClick={(e) => {
                e?.stopPropagation()
                handleChange(null)
              }}
            />
          </Box>
        )}
        {error && (
          <Typography variant="body2" color="error" sx={{ mt: 1 }}>
            {error}
          </Typography>
        )}
      </Paper>
    </Box>
  )
}

export default ResumeUpload
